import type { ReactNode } from "react";

const iconProps = {
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
};

const InsightCardIcons: Record<string, ReactNode> = {
    zia_active_block_rules: (
        <svg {...iconProps}>
            <path d="M12 3 20 7v5c0 5-3.4 8-8 9-4.6-1-8-4-8-9V7l8-4Z" />
            <path d="m9 9 6 6M15 9l-6 6" />
        </svg>
    ),

    zia_globally_scoped_rules: (
        <svg {...iconProps}>
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c2.4 2.5 3.5 5.5 3.5 9S14.4 18.5 12 21" />
            <path d="M12 3C9.6 5.5 8.5 8.5 8.5 12S9.6 18.5 12 21" />
        </svg>
    ),

    zpa_apps_no_rules: (
        <svg {...iconProps}>
            <rect x="3" y="4" width="18" height="16" rx="2" />
            <path d="M3 9h18M8 4v5" />
            <path d="M9 14h6M12 11v6" />
        </svg>
    ),

    zia_urllookup_quota: (
        <svg {...iconProps}>
            <path d="M4 18a8 8 0 1 1 16 0" />
            <path d="m12 12 4-4" />
            <circle cx="12" cy="18" r="1" fill="currentColor" stroke="none" />
            <path d="M6 18h12" />
        </svg>
    ),

    intune_noncompliant_windows: (
        <svg {...iconProps}>
            <path d="M3 4.5 10.5 3v8H3V4.5ZM13.5 2.5 21 1v10h-7.5V2.5Z" />
            <path d="M3 13h7.5v8L3 19.5V13ZM13.5 13H21v10l-7.5-1.5V13Z" />
        </svg>
    ),

    intune_stale_devices: (
        <svg {...iconProps}>
            <rect x="5" y="2" width="14" height="20" rx="2" />
            <path d="M9 5h6M10 18h4" />
            <circle cx="17.5" cy="15.5" r="4.5" fill="var(--surface)" />
            <path d="M17.5 13v2.5l1.5 1" />
        </svg>
    ),

    intune_os_below_minimum: (
        <svg {...iconProps}>
            <rect x="3" y="3" width="18" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
            <path d="M12 6v6M9.5 9.5 12 12l2.5-2.5" />
        </svg>
    ),

    unscoped_rules: (
        <svg {...iconProps}>
            <circle cx="12" cy="12" r="8" />
            <circle cx="12" cy="12" r="3" />
            <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
            <path d="m4.9 4.9 2.2 2.2M16.9 16.9l2.2 2.2" />
            <path d="m19.1 4.9-2.2 2.2M7.1 16.9l-2.2 2.2" />
        </svg>
    ),

    config_drift_zpa: (
        <svg {...iconProps}>
            <path d="M7 3v4M17 17v4" />
            <path d="M4 7h6M14 17h6" />
            <path d="M7 7c0 6 10 4 10 10" />
            <path d="m14 5 3-3 3 3M4 19l3 3 3-3" />
        </svg>
    ),

    config_drift_zia: (
        <svg {...iconProps}>
            <path d="M4 7h11M4 17h16M4 12h16" />
            <circle cx="18" cy="7" r="2" />
            <circle cx="8" cy="12" r="2" />
            <circle cx="14" cy="17" r="2" />
        </svg>
    ),

    intune_battery_attention: (
        <svg {...iconProps}>
            <rect x="3" y="7" width="16" height="10" rx="2" />
            <path d="M21 10v4M7 10v3M7 15h.01" />
        </svg>
    ),

    coverage_gap: (
        <svg {...iconProps}>
            <path d="M12 3 20 7v5c0 5-3.4 8-8 9-4.6-1-8-4-8-9V7l8-4Z" />
            <path d="M8 12h2M14 12h2" />
            <path d="M10 12h4" strokeDasharray="2 2" />
        </svg>
    ),

    intune_policy_hygiene: (
        <svg {...iconProps}>
            <path d="M6 3h9l3 3v15H6V3Z" />
            <path d="M15 3v4h4M9 11h6M9 15h4" />
            <path d="m15 18 1.5 1.5L20 16" />
        </svg>
    ),

    zscaler: (
        <svg {...iconProps}>
            <path d="M6.5 18.5h10a4.5 4.5 0 0 0 .6-9A6 6 0 0 0 5.8 8.3a5.2 5.2 0 0 0 .7 10.2Z" />
            <path d="M8 10h8l-8 5h8" />
        </svg>
    ),

    intune: (
        <svg {...iconProps}>
            <rect x="4" y="2" width="16" height="20" rx="2" />
            <path d="M8 6h8M8 10h8M8 14h4" />
            <path d="m14 17 2 2 4-4" />
        </svg>
    ),
};

export type InsightIconKey = keyof typeof InsightCardIcons;

export default InsightCardIcons;